module.exports = __webpack_public_path__ + "img/3.a03edea9.jpg";